export async function getUniqueMicrophones() {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    // 立即释放stream
    stream.getTracks().forEach((track) => {
      track.stop();
      track.enabled = false;
    });
    const devices = await navigator.mediaDevices.enumerateDevices();
    const microphones = [];
    if (devices) {
      devices.forEach((device) => {
        const filterDeviceIdArr = ['communications', 'default'];
        if (device.kind === 'audioinput' && !filterDeviceIdArr.includes(device.deviceId)) {
          microphones.push(device);
        }
      });
    }
    // 移除已关闭的stream，只返回麦克风列表
    return { microphones };
  } catch (error) {
    console.log('获取麦克风列表失败:', error);
    try {
      // 尝试使用虚拟设备
      return createVirtualMicrophone();
    } catch (virtualError) {
      console.error('虚拟设备也无法使用:', virtualError);
    }
  }
}
function createVirtualMicrophone() {
  const audioContext = new (window.AudioContext || window.webkitAudioContext)();
  const oscillator = audioContext.createOscillator();
  const destination = audioContext.createMediaStreamDestination();

  oscillator.connect(destination);
  oscillator.start();

  return destination.stream;
}
